import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import { Layout } from "./components/Layout";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { PreviewGate } from "./components/preview/PreviewGate";
import { LockedScreen } from "./components/preview/LockedScreen";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Properties from "./pages/Properties";
import PropertyDetail from "./pages/PropertyDetail";
import Documents from "./pages/Documents";
import Contacts from "./pages/Contacts";
import Settings from "./pages/Settings";

import "@/App.css";

// Extracted so the object identity is stable across renders.
const TOASTER_OPTIONS = {
  style: {
    fontFamily: "'IBM Plex Sans', ui-sans-serif, system-ui, sans-serif",
    fontSize: "13px",
  },
};

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <PreviewGate>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route
                element={
                  <ProtectedRoute>
                    <Layout />
                  </ProtectedRoute>
                }
              >
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
                <Route path="/dashboard" element={<LockedScreen locked={false}><Dashboard /></LockedScreen>} />
                <Route path="/properties" element={<LockedScreen locked={false}><Properties /></LockedScreen>} />
                <Route path="/properties/:id" element={<PropertyDetail />} />
                <Route path="/documents" element={<LockedScreen locked={false}><Documents /></LockedScreen>} />
                <Route path="/contacts" element={<LockedScreen locked={false}><Contacts /></LockedScreen>} />
                <Route
                  path="/settings"
                  element={
                    <LockedScreen>
                      <Settings />
                    </LockedScreen>
                  }
                />
              </Route>
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </PreviewGate>
          <Toaster position="top-right" toastOptions={TOASTER_OPTIONS} />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
